import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import {
  getAdditionalDiscounts,
  getDefaultDiscounts,
} from '~/services/Discounts';
import { Pagination } from '~/types';
import { AdditionalDiscount, DefaultDiscount } from '~/types/discount';

export function useAdditionalDiscounts(
  options: UseQueryOptions<Pagination<AdditionalDiscount>, unknown> = {},
): UseQueryResult<Pagination<AdditionalDiscount>, unknown> {
  return useQuery<Pagination<AdditionalDiscount>, unknown>(
    ['additional-discounts'],
    () => getAdditionalDiscounts(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useDefaultDiscounts(
  options: UseQueryOptions<Pagination<DefaultDiscount>, unknown> = {},
): UseQueryResult<Pagination<DefaultDiscount>, unknown> {
  return useQuery<Pagination<DefaultDiscount>, unknown>(
    ['default-discounts'],
    () => getDefaultDiscounts(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
